import React from 'react'
import { Tooltip } from 'antd'
import { FormLabels } from 'src/components'
import { AdminSaleOffer } from 'src/core/models'
import { getFirstSubstring } from 'src/core/helpers'

const AdminSaleOfferProjectColumn: React.FC<{ offer: AdminSaleOffer }> = ({ offer }) => {
  const vintageLabel = offer.vintage_year ? `(${offer.vintage_year})` : ''
  const projectlabel = `${offer.project_name} ${vintageLabel}`

  const projectSpan = <>
    {projectlabel.length >= 18 ? (
      <Tooltip title={projectlabel} color='cyan'>
        {`${getFirstSubstring(projectlabel, 18)}...`}
      </Tooltip>
    ): <>{projectlabel}</>}
  </>

  return <FormLabels title={projectSpan} subtitle={`${offer.project}`} />
}

export default AdminSaleOfferProjectColumn
